import { useCallback } from 'react';

import { ACCEPTED_FILE_TYPES } from '@sv-support-sdk/utils/src/constants/attachments';

import { useAppDispatch, useAppSelector } from '../store/hooks';
import ticketsActions from '../store/actions/tickets';
import { selectReplyAttachments } from '../store/selectors/tickets';
import { showSomethingWentWrongError } from '../store/actions/notifications';

export default () => {
  const dispatch = useAppDispatch();

  const replyAttachments = useAppSelector(selectReplyAttachments);

  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      const getUniqueFileName = (name: string) => {
        const sameNamesCount =
          replyAttachments &&
          replyAttachments.filter(
            (el) =>
              el.name === name ||
              el.name.match(
                new RegExp(
                  name.replace(/\.([^.]+)$/g, ' ([0-9]+).$1').replace(/\(|\)/g, '\\$&'),
                  'g',
                ),
              ),
          ).length;

        return sameNamesCount ? name.replace(/\.([^.]+)$/g, ` (${sameNamesCount}).$1`) : name;
      };

      acceptedFiles
        .filter((el) => ACCEPTED_FILE_TYPES.includes(el.type))
        .forEach((file: File) => {
          const reader = new FileReader();

          reader.onload = () => {
            dispatch(
              ticketsActions.addAttachmentToMessage(
                {
                  file: reader.result as string,
                  name: getUniqueFileName(file.name),
                  size: file.size,
                },
                () => dispatch(showSomethingWentWrongError()),
              ),
            );
          };

          reader.onabort = () => {
            dispatch(showSomethingWentWrongError());
          };

          reader.onerror = () => {
            dispatch(showSomethingWentWrongError());
          };

          reader.readAsDataURL(file);
        });
    },
    [replyAttachments, dispatch],
  );

  return [onDrop];
};
